// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-screen-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 8px 24px 20px;
  box-sizing: border-box;
  display: flex;
  overflow: hidden;
}

.chatbox-screen {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  min-height: 0;
}

.chatbox-screen.sidebar-collapsed {
  margin-inline-start: 0;
}

.chat-layout-container {
  height: 100%;
  width: 100%;
  min-width: 0;
  margin: 0;
  background: #f3f4f6;
  border-radius: 20px;
  border: 1px solid #d6dbe3;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);
}

.chat-layout-container.sidebar-open {
  /* Reserves space next to the sidebar's leading edge (left in LTR, right in RTL). */
  padding-inline-start: 260px;
  transition: padding-inline-start 0.25s ease;
}

.sidebar-btn {
  width: 28px !important;
  height: 28px !important;
  border-radius: 8px;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.sidebar-btn:hover {
  background-color: #ecf4ff;
  border-color: #b8d2f1;
}
.sidebar-btn.open {
  transform: rotate(180deg);
}

.sidebar-btn img {
  width: 18px;
  height: 18px;
}

.sidebar-btn-icon {
  color: #1f63ad;
  font-size: 16px !important;
  width: 16px;
  height: 16px;
}

.sidebar-btn.hidden {
  visibility: hidden;
}

.chatbot-header {
  height: 64px;
  flex-shrink: 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
}

.chatbot-header.blue-border {
  border-bottom: 2px solid #2c68ad;
}

.chatbot-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.chatbox-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-inline-start: auto;
  align-self: center;
  padding-top: 6px;
}

/* "New Chat" uses the shared \`.button .button--primary\` primitive for colours;
   these rules only tune sizing to fit the compact chat header. */
.new-chat-btn {
  min-height: 40px;
  padding: 10px 18px;
  font-size: 14px;
  line-height: 1;
}

.askDT-logo-inside-chat {
  width: 58px;
  height: 48px;
  margin-bottom: 8px;
}

.chatbox-heading {
  font-size: 14px;
  font-weight: 600;
  color: #1f4e8c;
  white-space: nowrap;
}

.conversation-area-chatbot {
  flex: 1 1 auto;
  width: 100%;
  /* Allow scrolling past welcome tiles / audience grids to reach message history */
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 24px 0;
  min-height: 0;
  box-sizing: border-box;
}

.conversation-area-chatbot.without-suggestions {
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 2px;
}

.conversation-area-chatbot.without-suggestions .chat-messages.empty {
  display: none;
}

/* One scroll area: the conversation column (global Chatbot.scss sets overflow on .chat-messages). */
.conversation-area-chatbot .chat-messages {
  overflow-y: visible;
  overflow-x: hidden;
}

.compact-input-chatbot {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  height: 44px;
  margin: 20px;
  border-radius: 60px;
}

.compact-input-chatbot input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.compact-input-chatbot input:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.compact-input-chatbot input:hover {
  border: none !important;
}

.campaign-screen-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 16px;
  margin: 0 16px 8px 35px;
  box-sizing: border-box;
}

.audience-list-empty-filter {
  margin: 0 16px 8px 35px;
}

.scrollable-chat {
  display: flex;
  flex-direction: column;
  height: auto;
  padding-bottom: 6px;
}

.dashboard-image-chatbot {
  margin-left: -10px;
  margin-right: -10px;
  width: 55px;
  height: 45px;
}

.sidebar-img {
  width: 55px !important;
  height: 45px !important;
}

.datatram-welcome-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 10px;
  margin-bottom: 18px;
}

.datatram-avatar {
  background: linear-gradient(145deg, #1f6ec0, #0f4e8c);
  color: #e9f3ff;
  border-radius: 14px;
  box-shadow: 0 10px 20px rgba(31, 99, 173, 0.2);
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 4px;
}

.datatram-greeting-title {
  font-size: 26px;
  font-weight: 700;
  color: #000000;
  letter-spacing: -0.02em;
}

.datatram-greeting-subtitle {
  font-size: 11px;
  color: #5e6f85;
  max-width: 900px;
  margin-bottom: 5px;
}

.datatram-suggestion-label {
  font-size: 15px;
  color: #5f6f83;
  margin: -10px 0 18px;
  text-align: center;
}

.datatram-quick-actions {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 14px 18px;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto 22px;
  margin-top: -20px;
}

.datatram-quick-actions .datatram-action-btn:nth-child(4) {
  grid-column: 2/span 2;
}

.datatram-quick-actions .datatram-action-btn:nth-child(5) {
  grid-column: 4/span 2;
}

.datatram-action-btn {
  background: #edf3fb;
  border: 1px solid #dbe8f8;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  grid-column: span 2;
}

.new-chat-btn {
  align-items: center;
}

.datatram-action-btn:hover {
  background-color: #e6effb;
  border-color: #c8ddf6;
}

.datatram-action-icon {
  color: #1f63ad;
  line-height: 0;
  margin-bottom: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.datatram-action-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.datatram-action-title {
  font-size: 12px;
  line-height: 1.2;
  color: #2c68ad;
  font-weight: 700;
  letter-spacing: 0;
}

.datatram-action-subtitle {
  font-size: 10px;
  line-height: 1.25;
  color: #6A6A6A;
  font-weight: 400;
}

@media (max-width: 1024px) {
  .datatram-suggestion-label {
    font-size: 16px;
  }
  .datatram-greeting-title {
    font-size: 48px;
  }
  .datatram-greeting-subtitle {
    font-size: 15px;
  }
  .datatram-action-title {
    font-size: 16px;
  }
  .datatram-action-subtitle {
    font-size: 12px;
  }
  .datatram-quick-actions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .datatram-action-btn {
    grid-column: span 1;
  }
  .datatram-quick-actions .datatram-action-btn:nth-child(4),
  .datatram-quick-actions .datatram-action-btn:nth-child(5) {
    grid-column: auto;
  }
}
@media (max-width: 768px) {
  .datatram-suggestion-label {
    font-size: 14px;
    margin: -6px 0 14px;
  }
  .datatram-greeting-title {
    font-size: 34px;
  }
  .datatram-greeting-subtitle {
    font-size: 14px;
  }
  .datatram-action-title {
    font-size: 15px;
  }
  .datatram-action-subtitle {
    font-size: 12px;
  }
  .datatram-quick-actions {
    grid-template-columns: 1fr;
  }
  .datatram-action-btn {
    grid-column: span 1;
  }
  .new-chat-btn {
    font-size: 12px;
    padding: 10px 16px;
    border-radius: 10px;
  }
}
.chat-screen-input-shell {
  width: 100%;
  flex-shrink: 0;
  padding: 10px 0 14px;
  box-sizing: border-box;
}

.chat-screen-input-shell .compact-input-area {
  display: flex !important;
  flex-direction: column !important;
  gap: 0 !important;
  width: calc(100% - 40px) !important;
  min-width: 0;
  margin: 0 auto !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.chat-screen-input-shell .compact-input-area .input-row {
  gap: 2px;
  min-height: 52px;
  padding: 0 22px;
  border: 1px solid #cfcfcf;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: none;
  box-sizing: border-box;
}

.chat-screen-input-shell .compact-input-area .chat-composer-panel .chat-composer-panel__input-slot .input-row {
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 6px 0 10px !important;
  min-height: 48px;
}

.chat-screen-input-shell .input-row input {
  font-size: 12px;
  color: #111827;
  min-height: 50px;
  padding: 0 8px;
}

.chat-screen-input-shell .chatbot-send-button {
  width: 28px;
  height: 28px;
  color: #1f63ad;
}

.chat-screen-input-shell .chat-input-icon-button {
  width: 32px !important;
  height: 32px !important;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
}

.chat-screen-input-shell .compact-input-area .chat-input-icon-button,
.chat-screen-input-shell .compact-input-area .chatbot-send-button {
  margin-left: 0 !important;
  width: 26px !important;
  height: 26px !important;
  padding: 2px !important;
}

.chat-screen-input-shell .input-row .chat-input-icon {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  color: #1f63ad;
  stroke: currentColor;
  margin: 0 !important;
  transform: none !important;
}

.chat-screen-input-shell .input-row .clip-icon.chat-input-icon {
  transform: rotate(135deg) !important;
  transform-origin: center;
}

.chat-screen-input-shell .chat-input-attachment-hints {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 24px;
  padding: 8px 4px 0;
  color: #9a9a9a;
  font-size: 10px;
  line-height: 1.3;
}

.chat-screen-input-shell .chat-input-attachment-hint {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.chat-screen-input-shell .chat-input-attachment-hint svg {
  flex: 0 0 auto;
  width: 12px;
  height: 12px;
  color: #8ba0bd;
  stroke-width: 2.2;
}

.chat-screen-input-shell .chat-composer-panel {
  width: 100%;
}

.system-notice-row {
  align-items: flex-start;
}

.system-notice-bubble {
  background: #f5f7fa;
  border: 1px solid #d7e0ec;
  color: #374151;
  font-size: 13px;
  line-height: 1.45;
}

.chat-layout {
  display: flex;
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
  min-width: 0;
}

@media (max-width: 1200px) {
  .chatbot-screen-container {
    padding: 8px 16px 16px;
  }
  .datatram-quick-actions {
    max-width: 860px;
  }
}
@media (max-width: 992px) {
  .chat-layout-container.sidebar-open {
    padding-inline-start: 0;
  }
  .chatbox-screen {
    margin-inline-start: 0;
    width: 100%;
  }
  .conversation-area-chatbot {
    width: 100%;
    padding: 10px 18px 0;
  }
  .campaign-screen-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-left: 16px;
  }
  .audience-list-empty-filter {
    margin-left: 16px;
  }
}
@media (max-width: 768px) {
  .chatbot-screen-container {
    padding: 8px;
  }
  .chat-layout-container {
    border-radius: 14px;
  }
  .chatbot-header {
    height: 58px;
    padding: 0 12px;
  }
  .conversation-area-chatbot {
    padding: 8px 12px 0;
  }
  .campaign-screen-grid {
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 0 8px 8px;
  }
  .compact-input-area {
    margin: 2px 8px 8px;
  }
}
@media (max-width: 480px) {
  .chatbot-screen-container {
    padding: 0;
  }
  .chat-layout-container {
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }
  .chatbot-header {
    height: 52px;
  }
  .new-chat-btn {
    padding: 9px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/AskDatatram/ChatScreen.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;;AAIA;EACE,mFAAA;EACA,2BAAA;EACA,2CAAA;AADF;;AAIA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;EACA,qBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;;AAMA;EACE,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,cAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAHF;;AAMA;iEAAA;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,cAAA;EACA,WAAA;EACA,iFAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AAHF;;AAMA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA,oGAAA;AACA;EACE,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,sBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qDAAA;EACA,cAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,qBAAA;AAHF;;AAMA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAHF;;AAMA;EACE;IACE,eAAA;EAHF;EAMA;IACE,eAAA;EAJF;EAOA;IACE,eAAA;EALF;EAQA;IACE,eAAA;EANF;EASA;IACE,eAAA;EAPF;EAUA;IACE,gDAAA;EARF;EAWA;IACE,mBAAA;EATF;EAYA;;IAEE,iBAAA;EAVF;AACF;AAaA;EACE;IACE,eAAA;IACA,mBAAA;EAXF;EAcA;IACE,eAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,eAAA;EAdF;EAiBA;IACE,eAAA;EAfF;EAkBA;IACE,0BAAA;EAhBF;EAmBA;IACE,mBAAA;EAjBF;EAoBA;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EAlBF;AACF;AAqBA;EACE,WAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,wBAAA;EACA,iCAAA;EACA,iBAAA;EACA,mCAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;AAnBF;;AAsBA;EACE,QAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAnBF;;AAsBA;EAKE,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;AAvBF;;AA0BA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAvBF;;AA0BA;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAvBF;;AA0BA;;EAEE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,0BAAA;AAvBF;;AA0BA;EACE,oCAAA;EACA,wBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvBF;;AA0BA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,WAAA;AAvBF;;AA0BA;EACE,uBAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AAvBF;;AA0BA;EACE;IACE,sBAAA;EAvBF;EA0BA;IACE,gBAAA;EAxBF;AACF;AA2BA;EACE;IACE,uBAAA;EAzBF;EA4BA;IACE,sBAAA;IACA,WAAA;EA1BF;EA6BA;IACE,WAAA;IACA,oBAAA;EA3BF;EA8BA;IACE,gDAAA;IACA,iBAAA;EA5BF;EA+BA;IACE,iBAAA;EA7BF;AACF;AAgCA;EACE;IACE,YAAA;EA9BF;EAiCA;IACE,mBAAA;EA/BF;EAkCA;IACE,YAAA;IACA,eAAA;EAhCF;EAmCA;IACE,mBAAA;EAjCF;EAoCA;IACE,0BAAA;IACA,SAAA;IACA,iBAAA;EAlCF;EAqCA;IACE,mBAAA;EAnCF;AACF;AAsCA;EACE;IACE,UAAA;EApCF;EAuCA;IACE,gBAAA;IACA,cAAA;IACA,eAAA;EArCF;EAwCA;IACE,YAAA;EAtCF;EAyCA;IACE,iBAAA;EAvCF;AACF","sourcesContent":[".chatbot-screen-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  padding: 8px 24px 20px;\n  box-sizing: border-box;\n  display: flex;\n  overflow: hidden;\n}\n\n.chatbox-screen {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  min-height: 0;\n}\n\n.chatbox-screen.sidebar-collapsed {\n  margin-inline-start: 0;\n}\n\n.chat-layout-container {\n  height: 100%;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  background: #f3f4f6;\n  border-radius: 20px;\n  border: 1px solid #d6dbe3;\n\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.18);\n\n}\n\n.chat-layout-container.sidebar-open {\n  /* Reserves space next to the sidebar's leading edge (left in LTR, right in RTL). */\n  padding-inline-start: 260px;\n  transition: padding-inline-start 0.25s ease;\n}\n\n.sidebar-btn {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 8px;\n  border: none;\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #ecf4ff;\n    border-color: #b8d2f1;\n  }\n\n  &.open {\n    transform: rotate(180deg);\n  }\n}\n\n.sidebar-btn img {\n  width: 18px;\n  height: 18px;\n}\n\n.sidebar-btn-icon {\n  color: #1f63ad;\n  font-size: 16px !important;\n  width: 16px;\n  height: 16px;\n}\n\n.sidebar-btn.hidden {\n  visibility: hidden;\n}\n\n.chatbot-header {\n  height: 64px;\n  flex-shrink: 0;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.chatbot-header.blue-border {\n  border-bottom: 2px solid #2c68ad;\n}\n\n.chatbot-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.chatbox-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-inline-start: auto;\n  align-self: center;\n  padding-top: 6px;\n}\n\n/* \"New Chat\" uses the shared `.button .button--primary` primitive for colours;\n   these rules only tune sizing to fit the compact chat header. */\n.new-chat-btn {\n  min-height: 40px;\n  padding: 10px 18px;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.askDT-logo-inside-chat {\n  width: 58px;\n  height: 48px;\n  margin-bottom: 8px;\n}\n\n.chatbox-heading {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f4e8c;\n  white-space: nowrap;\n}\n\n.conversation-area-chatbot {\n  flex: 1 1 auto;\n  width: 100%;\n  /* Allow scrolling past welcome tiles / audience grids to reach message history */\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 10px 24px 0;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.conversation-area-chatbot.without-suggestions {\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-bottom: 2px;\n}\n\n.conversation-area-chatbot.without-suggestions .chat-messages.empty {\n  display: none;\n}\n\n/* One scroll area: the conversation column (global Chatbot.scss sets overflow on .chat-messages). */\n.conversation-area-chatbot .chat-messages {\n  overflow-y: visible;\n  overflow-x: hidden;\n}\n\n.compact-input-chatbot {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  height: 44px;\n  margin: 20px;\n  border-radius: 60px;\n}\n\n.compact-input-chatbot input {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n}\n\n.compact-input-chatbot input:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.compact-input-chatbot input:hover {\n  border: none !important;\n}\n\n.campaign-screen-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px 16px;\n  margin: 0 16px 8px 35px;\n  box-sizing: border-box;\n}\n\n.audience-list-empty-filter {\n  margin: 0 16px 8px 35px;\n}\n\n.scrollable-chat {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  padding-bottom: 6px;\n}\n\n.dashboard-image-chatbot {\n  margin-left: -10px;\n  margin-right: -10px;\n  width: 55px;\n  height: 45px;\n}\n\n.sidebar-img {\n  width: 55px !important;\n  height: 45px !important;\n}\n\n.datatram-welcome-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding-top: 10px;\n  margin-bottom: 18px;\n}\n\n.datatram-avatar {\n  background: linear-gradient(145deg, #1f6ec0, #0f4e8c);\n  color: #e9f3ff;\n  border-radius: 14px;\n  box-shadow: 0 10px 20px rgba(31, 99, 173, 0.2);\n  width: 54px;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  margin-top: 4px;\n}\n\n.datatram-greeting-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: #000000;\n  letter-spacing: -0.02em;\n}\n\n.datatram-greeting-subtitle {\n  font-size: 11px;\n  color: #5e6f85;\n  max-width: 900px;\n  margin-bottom: 5px;\n}\n\n.datatram-suggestion-label {\n  font-size: 15px;\n  color: #5f6f83;\n  margin: -10px 0 18px;\n  text-align: center;\n}\n\n.datatram-quick-actions {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 14px 18px;\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto 22px;\n  margin-top: -20px;\n}\n\n.datatram-quick-actions .datatram-action-btn:nth-child(4) {\n  grid-column: 2 / span 2;\n}\n\n.datatram-quick-actions .datatram-action-btn:nth-child(5) {\n  grid-column: 4 / span 2;\n}\n\n.datatram-action-btn {\n  background: #edf3fb;\n  border: 1px solid #dbe8f8;\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  min-height: 100px;\n  width: 100%;\n  box-shadow: none;\n  grid-column: span 2;\n}\n\n.new-chat-btn {\n  align-items: center;\n}\n\n.datatram-action-btn:hover {\n  background-color: #e6effb;\n  border-color: #c8ddf6;\n}\n\n.datatram-action-icon {\n  color: #1f63ad;\n  line-height: 0;\n  margin-bottom: 2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.datatram-action-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.datatram-action-title {\n  font-size: 12px;\n  line-height: 1.2;\n  color: #2c68ad;\n  font-weight: 700;\n  letter-spacing: 0;\n}\n\n.datatram-action-subtitle {\n  font-size: 10px;\n  line-height: 1.25;\n  color: #6A6A6A;\n  font-weight: 400;\n}\n\n@media (max-width: 1024px) {\n  .datatram-suggestion-label {\n    font-size: 16px;\n  }\n\n  .datatram-greeting-title {\n    font-size: 48px;\n  }\n\n  .datatram-greeting-subtitle {\n    font-size: 15px;\n  }\n\n  .datatram-action-title {\n    font-size: 16px;\n  }\n\n  .datatram-action-subtitle {\n    font-size: 12px;\n  }\n\n  .datatram-quick-actions {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .datatram-action-btn {\n    grid-column: span 1;\n  }\n\n  .datatram-quick-actions .datatram-action-btn:nth-child(4),\n  .datatram-quick-actions .datatram-action-btn:nth-child(5) {\n    grid-column: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .datatram-suggestion-label {\n    font-size: 14px;\n    margin: -6px 0 14px;\n  }\n\n  .datatram-greeting-title {\n    font-size: 34px;\n  }\n\n  .datatram-greeting-subtitle {\n    font-size: 14px;\n  }\n\n  .datatram-action-title {\n    font-size: 15px;\n  }\n\n  .datatram-action-subtitle {\n    font-size: 12px;\n  }\n\n  .datatram-quick-actions {\n    grid-template-columns: 1fr;\n  }\n\n  .datatram-action-btn {\n    grid-column: span 1;\n  }\n\n  .new-chat-btn {\n    font-size: 12px;\n    padding: 10px 16px;\n    border-radius: 10px;\n  }\n}\n\n.chat-screen-input-shell {\n  width: 100%;\n  flex-shrink: 0;\n  padding: 10px 0 14px;\n  box-sizing: border-box;\n}\n\n.chat-screen-input-shell .compact-input-area {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0 !important;\n  width: calc(100% - 40px) !important;\n  min-width: 0;\n  margin: 0 auto !important;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.chat-screen-input-shell .compact-input-area .input-row {\n  gap: 2px;\n  min-height: 52px;\n  padding: 0 22px;\n  border: 1px solid #cfcfcf;\n  border-radius: 999px;\n  background: #ffffff;\n  box-shadow: none;\n  box-sizing: border-box;\n}\n\n.chat-screen-input-shell\n  .compact-input-area\n  .chat-composer-panel\n  .chat-composer-panel__input-slot\n  .input-row {\n  border: none !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  padding: 0 6px 0 10px !important;\n  min-height: 48px;\n}\n\n.chat-screen-input-shell .input-row input {\n  font-size: 12px;\n  color: #111827;\n  min-height: 50px;\n  padding: 0 8px;\n}\n\n.chat-screen-input-shell .chatbot-send-button {\n  width: 28px;\n  height: 28px;\n  color: #1f63ad;\n}\n\n.chat-screen-input-shell .chat-input-icon-button {\n  width: 32px !important;\n  height: 32px !important;\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  cursor: pointer;\n}\n\n.chat-screen-input-shell .compact-input-area .chat-input-icon-button,\n.chat-screen-input-shell .compact-input-area .chatbot-send-button {\n  margin-left: 0 !important;\n  width: 26px !important;\n  height: 26px !important;\n  padding: 2px !important;\n}\n\n.chat-screen-input-shell .input-row .chat-input-icon {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n  color: #1f63ad;\n  stroke: currentColor;\n  margin: 0 !important;\n  transform: none !important;\n}\n\n.chat-screen-input-shell .input-row .clip-icon.chat-input-icon {\n  transform: rotate(135deg) !important;\n  transform-origin: center;\n}\n\n.chat-screen-input-shell .chat-input-attachment-hints {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px 24px;\n  padding: 8px 4px 0;\n  color: #9a9a9a;\n  font-size: 10px;\n  line-height: 1.3;\n}\n\n.chat-screen-input-shell .chat-input-attachment-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.chat-screen-input-shell .chat-input-attachment-hint svg {\n  flex: 0 0 auto;\n  width: 12px;\n  height: 12px;\n  color: #8ba0bd;\n  stroke-width: 2.2;\n}\n\n.chat-screen-input-shell .chat-composer-panel {\n  width: 100%;\n}\n\n.system-notice-row {\n  align-items: flex-start;\n}\n\n.system-notice-bubble {\n  background: #f5f7fa;\n  border: 1px solid #d7e0ec;\n  color: #374151;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.chat-layout {\n  display: flex;\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 0;\n  min-width: 0;\n}\n\n@media (max-width: 1200px) {\n  .chatbot-screen-container {\n    padding: 8px 16px 16px;\n  }\n\n  .datatram-quick-actions {\n    max-width: 860px;\n  }\n}\n\n@media (max-width: 992px) {\n  .chat-layout-container.sidebar-open {\n    padding-inline-start: 0;\n  }\n\n  .chatbox-screen {\n    margin-inline-start: 0;\n    width: 100%;\n  }\n\n  .conversation-area-chatbot {\n    width: 100%;\n    padding: 10px 18px 0;\n  }\n\n  .campaign-screen-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    margin-left: 16px;\n  }\n\n  .audience-list-empty-filter {\n    margin-left: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .chatbot-screen-container {\n    padding: 8px;\n  }\n\n  .chat-layout-container {\n    border-radius: 14px;\n  }\n\n  .chatbot-header {\n    height: 58px;\n    padding: 0 12px;\n  }\n\n  .conversation-area-chatbot {\n    padding: 8px 12px 0;\n  }\n\n  .campaign-screen-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    margin: 0 8px 8px;\n  }\n\n  .compact-input-area {\n    margin: 2px 8px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .chatbot-screen-container {\n    padding: 0;\n  }\n\n  .chat-layout-container {\n    border-radius: 0;\n    border-left: 0;\n    border-right: 0;\n  }\n\n  .chatbot-header {\n    height: 52px;\n  }\n\n  .new-chat-btn {\n    padding: 9px 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
